export const GET_THEME_LIST = 'GET_THEME_LIST'
export const GET_THEME_BY_ID = 'GET_THEME_BY_ID'
export const GET_DEFAULT_THEME = 'GET_DEFAULT_THEME'
export const ADD_THEME = 'ADD_THEME'
export const UPDATE_THEME = 'UPDATE_THEME'
export const DELETE_THEME = 'DELETE_THEME'
export const GET_SELECTED_THEME = 'GET_SELECTED_THEME'
export const SET_SELECTED_THEME = 'SET_SELECTED_THEME'
export const UPDATE_THEME_TITLE = 'UPDATE_THEME_TITLE'

export const SET_THEME_LIST = 'SET_THEME_LIST'
export const SET_CURRENT_THEME = 'SET_CURRENT_THEME'
export const SET_CURRENT_THEME_ID = 'SET_CURRENT_THEME_ID'
export const SET_THEME_LOADING = 'SET_THEME_LOADING'
